// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../../usr/lib/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../../usr/lib/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* The default CSS for authenticator portal. */

.firebaseui-auth-outcontainer {
	display: flex;
	justify-content: center;
	align-items: center;
}

.firebaseui-auth-container {
	display: inline-block;
}

.firebaseui-auth-title {
	margin: 9px;
	padding: 8px;
	text-align: center;
	font-weight: bolder;
	font-size: 1.2em;
}

.firebaseui-auth-opt
{
	margin: 9px;
	padding: 8px;
	width: 300px;
	text-align: center;
	cursor: pointer;
	box-shadow: 1.5px 1.5px 3px gray;
	border-radius: 2px;
	font-size: 14px;
	font-family: "Roboto","Helvetica","Arial",sans-serif;
}
.firebaseui-auth-opt:hover { box-shadow: 2px 2px 5px #71b2f5; }
.firebaseui-auth-opt:active
{
	box-shadow: 0px 0px 5px gray;
	position: relative;
	left: 1px;
	top: 1px;
}

.firebaseui-icon	{ height: 20px; width: 20px; float: left; }

.firebaseui-auth-waitspin{
	text-align: center;
	display: block;
	font-size: 4em;
	margin-top: 2em;
}

.auth-btn-google	{ background-color: #fff; color: #757575; }
.auth-btn-facebook	{ background-color: #3b5998; color: #fff; }
.auth-btn-email		{ background-color: #de5246; color: #fff; }
.auth-btn-twitter	{ background-color: #00acee; color: #fff; }
`, "",{"version":3,"sources":["webpack://./esm_src/bundle/authenticator/css/authenticator.css"],"names":[],"mappings":"AAAA,8CAA8C;;AAE9C;CACC,aAAa;CACb,uBAAuB;CACvB,mBAAmB;AACpB;;AAEA;CACC,qBAAqB;AACtB;;AAEA;CACC,WAAW;CACX,YAAY;CACZ,kBAAkB;CAClB,mBAAmB;CACnB,gBAAgB;AACjB;;AAEA;;CAEC,WAAW;CACX,YAAY;CACZ,YAAY;CACZ,kBAAkB;CAClB,eAAe;CACf,gCAAgC;CAChC,kBAAkB;CAClB,eAAe;CACf,oDAAoD;AACrD;AACA,6BAA6B,+BAA+B,EAAE;AAC9D;;CAEC,4BAA4B;CAC5B,kBAAkB;CAClB,SAAS;CACT,QAAQ;AACT;;AAEA,mBAAmB,YAAY,EAAE,WAAW,EAAE,WAAW,EAAE;;AAE3D;CACC,kBAAkB;CAClB,cAAc;CACd,cAAc;CACd,eAAe;AAChB;;AAEA,mBAAmB,sBAAsB,EAAE,cAAc,EAAE;AAC3D,qBAAqB,yBAAyB,EAAE,WAAW,EAAE;AAC7D,mBAAmB,yBAAyB,EAAE,WAAW,EAAE;AAC3D,oBAAoB,yBAAyB,EAAE,WAAW,EAAE","sourcesContent":["/* The default CSS for authenticator portal. */\n\n.firebaseui-auth-outcontainer {\n\tdisplay: flex;\n\tjustify-content: center;\n\talign-items: center;\n}\n\n.firebaseui-auth-container {\n\tdisplay: inline-block;\n}\n\n.firebaseui-auth-title {\n\tmargin: 9px;\n\tpadding: 8px;\n\ttext-align: center;\n\tfont-weight: bolder;\n\tfont-size: 1.2em;\n}\n\n.firebaseui-auth-opt\n{\n\tmargin: 9px;\n\tpadding: 8px;\n\twidth: 300px;\n\ttext-align: center;\n\tcursor: pointer;\n\tbox-shadow: 1.5px 1.5px 3px gray;\n\tborder-radius: 2px;\n\tfont-size: 14px;\n\tfont-family: \"Roboto\",\"Helvetica\",\"Arial\",sans-serif;\n}\n.firebaseui-auth-opt:hover { box-shadow: 2px 2px 5px #71b2f5; }\n.firebaseui-auth-opt:active\n{\n\tbox-shadow: 0px 0px 5px gray;\n\tposition: relative;\n\tleft: 1px;\n\ttop: 1px;\n}\n\n.firebaseui-icon\t{ height: 20px; width: 20px; float: left; }\n\n.firebaseui-auth-waitspin{\n\ttext-align: center;\n\tdisplay: block;\n\tfont-size: 4em;\n\tmargin-top: 2em;\n}\n\n.auth-btn-google\t{ background-color: #fff; color: #757575; }\n.auth-btn-facebook\t{ background-color: #3b5998; color: #fff; }\n.auth-btn-email\t\t{ background-color: #de5246; color: #fff; }\n.auth-btn-twitter\t{ background-color: #00acee; color: #fff; }\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
